import { Box, styled } from '@mui/material';

const StyBoxAdmin = styled(Box, {
    name: 'StyBox',
})({
    backgroundColor: 'white',
    padding: '1rem',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});

export default StyBoxAdmin;
